import React, { useState } from 'react';
import { ClipboardList, Award, CheckCircle2, RefreshCw } from 'lucide-react';

export const AssessmentModule: React.FC = () => {
  const [sensoryScore, setSensoryScore] = useState(78);
  const [cars2Rating, setCars2Rating] = useState('Moderate Autism (Score: 34.5)');
  const [vinelandScore, setVinelandScore] = useState(82);
  const [isCalculated, setIsCalculated] = useState(true);
  const [msg, setMsg] = useState('');

  const handleRecalculate = () => {
    setIsCalculated(false);
    setTimeout(() => {
      setIsCalculated(true);
      setMsg('Diagnostic profile updated and clinical metrics synced!');
      setTimeout(() => setMsg(''), 4000);
    }, 400);
  };

  return (
    <div className="bg-white rounded-2xl border border-slate-200 p-6 shadow-sm space-y-6">
      <div className="flex items-center justify-between border-b border-slate-100 pb-4">
        <div>
          <span className="px-2.5 py-0.5 bg-indigo-100 text-indigo-800 text-[10px] font-bold rounded-full uppercase tracking-wider">
            Diagnostic & Standardized Assessment Protocol
          </span>
          <h2 className="text-2xl font-bold text-slate-900 mt-1">Diagnostic Clinical Assessment Engine</h2>
          <p className="text-xs text-slate-500">Sensory Profile 2, CARS-2, Vineland-3, and standardized developmental scoring</p>
        </div>

        <button 
          onClick={handleRecalculate}
          className="px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white font-bold text-xs rounded-xl shadow transition flex items-center gap-1.5"
        >
          <RefreshCw className="w-4 h-4" />
          <span>Recalculate Scores</span>
        </button>
      </div>

      {msg && (
        <div className="p-3 bg-emerald-50 border border-emerald-200 text-emerald-900 rounded-xl text-xs font-bold flex items-center gap-2">
          <CheckCircle2 className="w-4 h-4 text-emerald-600" />
          {msg}
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-3">
          <div className="text-xs font-bold text-slate-500">Sensory Profile 2 Index</div>
          <div className="text-2xl font-black text-indigo-600 font-mono">{sensoryScore} / 100</div>
          <input 
            type="range" min="0" max="100" value={sensoryScore}
            onChange={(e) => setSensoryScore(parseInt(e.target.value))}
            className="w-full accent-indigo-600"
          />
          <div className="text-[10px] text-slate-500">Auditory Seek & Tactile Sensitivity Elevated</div>
        </div>

        <div className="p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-3">
          <div className="text-xs font-bold text-slate-500">CARS-2 Rating Tier</div>
          <select 
            value={cars2Rating} 
            onChange={(e) => setCars2Rating(e.target.value)}
            className="w-full px-3 py-1.5 border rounded-xl text-xs font-bold bg-white focus:ring-2 focus:ring-indigo-500"
          >
            <option value="Mild-to-Moderate Autism (Score: 31.0)">Mild-to-Moderate Autism (Score: 31.0)</option>
            <option value="Moderate Autism (Score: 34.5)">Moderate Autism (Score: 34.5)</option>
            <option value="Severe Autism (Score: 39.0)">Severe Autism (Score: 39.0)</option>
          </select>
          <div className="text-[10px] text-slate-500">Childhood Autism Rating Scale v2</div>
        </div>

        <div className="p-4 bg-slate-50 border border-slate-200 rounded-xl space-y-3">
          <div className="text-xs font-bold text-slate-500">Vineland-3 Adaptive Composite</div>
          <div className="text-2xl font-black text-emerald-600 font-mono">{vinelandScore} Standard Score</div>
          <input 
            type="range" min="40" max="160" value={vinelandScore}
            onChange={(e) => setVinelandScore(parseInt(e.target.value))}
            className="w-full accent-emerald-600"
          />
          <div className="text-[10px] text-slate-500">Communication & Daily Living Skills</div>
        </div>
      </div>
    </div>
  );
};
